import { Injectable } from '@angular/core';

export type CookieConsentLevel = 'all' | 'necessary' | 'none';
export type disclaimerConsentLevel = 'accepted' | 'rejected';

@Injectable({
  providedIn: 'root'
})
export class CookiesService {
private storageKey = 'cookieConsent';
private storageKeyDisclaimer = 'disclaimerConsent';

  constructor() {}

  setConsent(level: CookieConsentLevel) {
    this.setCookie(this.storageKey, level)
    this.applyConsent(level);
  }

  setDisclaimerConsent(level: disclaimerConsentLevel) {
    this.setCookie(this.storageKeyDisclaimer, level)
  }
  getDisclaimerConsent() {
    return this.getCookie(this.storageKeyDisclaimer) as disclaimerConsentLevel | null;
  }

  getConsent(): CookieConsentLevel | null {
    return this.getCookie(this.storageKey) as CookieConsentLevel | null;
  }

  hasConsent(level: CookieConsentLevel): boolean {
    const consent = this.getConsent();
    return consent === level || (level === 'necessary' && consent === 'all');
  }

  clearConsent() {
    localStorage.removeItem(this.storageKey);
    this.deleteAllCookies();
  }

  /** Apply consent choice */
  private applyConsent(level: CookieConsentLevel) {
    if (level === 'none') {
      this.deleteAllCookies();
      this.blockThirdPartyScripts();
    } else if (level === 'necessary') {
      this.deleteNonEssentialCookies();
      this.blockThirdPartyScripts();
    } else if (level === 'all') {
      this.loadThirdPartyScripts();
    }
  }

  /** Set a cookie */
  setCookie(name: string, value: string, days: number = 365) {
    document.cookie = `${name}=${value}; path=/; max-age=${days * 24 * 60 * 60}`;
  }

  /** get cookies */
  getCookie(name: string): string | null {
    const nameEQ = name + "=";
    const cookiesArray = document.cookie.split(';');
    for (let cookie of cookiesArray) {
      cookie = cookie.trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length);
      }
    }
    return null;
  }

  /** Delete all cookies */
  private deleteAllCookies() {
    document.cookie.split(';').forEach(cookie => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    });
  }

  /** Delete non-essential cookies */
  private deleteNonEssentialCookies() {
    // Example: Keep session & csrf cookies only
    document.cookie.split(';').forEach(cookie => {
      const name = cookie.split('=')[0].trim();
      if (!['session_id', 'XSRF-TOKEN'].includes(name)) {
        document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      }
    });
  }

  /** Block scripts before consent */
  private blockThirdPartyScripts() {
    const blockedScripts = document.querySelectorAll('script[data-blocked="true"]');
    blockedScripts.forEach(script => script.remove());
  }

  /** Load scripts dynamically after consent */
  private loadThirdPartyScripts() {
    // Example: Load Google Analytics after consent
    if (!document.getElementById('ga-script')) {
      const script = document.createElement('script');
      script.id = 'ga-script';
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-XXXXXXX';
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        (window as any).dataLayer = (window as any).dataLayer || [];
        function gtag(...args: any[]) { (window as any).dataLayer.push(args); }
        gtag('js', new Date());
        gtag('config', 'G-XXXXXXX');
      };
    }
  }
}
